<template>
  <Row>
    <Card dis-hover>
      <i-form-item label="Methodology">
        <CheckboxGroup
          v-model="currentValue.methodology"
          @on-change="updateValue"
        >
          <Checkbox label="Registration"></Checkbox>
          <Checkbox label="Key informants"></Checkbox>
          <Checkbox label="Media monitoring"></Checkbox>
          <Checkbox label="Satellite imagery"></Checkbox>
          <Checkbox label="Unknown"></Checkbox>
          <Checkbox label="Other"></Checkbox>
        </CheckboxGroup>
      </i-form-item>
    </Card>

    <Card dis-hover>
      <i-form-item label="Data Trianglation">
        <RadioGroup
          v-model="currentValue.data_trianglation"
          @on-change="updateValue"
        >
          <Radio label="Good triangulation"></Radio>
          <Radio label="Some local triangulation"></Radio>
          <Radio label="Contradictory data"></Radio>
          <Radio label="No Triangulation"></Radio>
        </RadioGroup>
      </i-form-item>
    </Card>
    <Card dis-hover>
      <i-form-item label="Geographical Coverage">
        <RadioGroup
          v-model="currentValue.geographical_coverage"
          @on-change="updateValue"
        >
          <Radio label="All relevant areas covered"></Radio>
          <Radio label="Partial coverage"></Radio>
          <Radio label="Unknown"></Radio>
        </RadioGroup>
      </i-form-item>
    </Card>
    <Card dis-hover>
      <i-form-item label="Geographical Disaggregation">
        <RadioGroup
          v-model="currentValue.geographical_disaggregation"
          @on-change="updateValue"
        >
          <Radio label="Country/territory - admin 0"></Radio>
          <Radio label="Subnational - admin 1"></Radio>
          <Radio label="Admin 2 or more"></Radio>
          <Radio label="Unknown"></Radio>
        </RadioGroup>
      </i-form-item>
      <Card dis-hover> </Card>
      <i-form-item label="Reporting Unit(s)">
        <CheckboxGroup
          v-model="currentValue.reporting_units"
          @on-change="updateValue"
        >
          <Checkbox label="People"></Checkbox>
          <Checkbox label="Households"></Checkbox>
          <Checkbox label="Percentage of population"></Checkbox>
        </CheckboxGroup>
      </i-form-item>
    </Card>
    <Card dis-hover>
      <i-form-item label="Frequency of Reporting">
        <RadioGroup
          v-model="currentValue.frequency_of_reporting"
          @on-change="updateValue"
        >
          <Radio label="Once a year"></Radio>
          <Radio label="Every 6 months"></Radio>
          <Radio label="Every 3 months"></Radio>
          <Radio label="Every month"></Radio>
          <Radio label="More than once a month"></Radio>
          <Radio label="No update"></Radio>
          <Radio label="Upon request"></Radio>
          <Radio label="Other"></Radio>
          <Radio label="Unknown"></Radio>
        </RadioGroup>
      </i-form-item>
    </Card>

    <Row>
      <i-col span="12">
        <Card dis-hover>
          <i-form-item label="Disaggregation Sex">
            <RadioGroup
              v-model="currentValue.disaggregation_sex"
              @on-change="updateValue"
            >
              <Radio label="Yes"></Radio>
              <Radio label="No"></Radio>
              <Radio label="Partial"></Radio>
            </RadioGroup>
          </i-form-item>
        </Card>
      </i-col>
      <i-col span="12">
        <Card dis-hover>
          <i-form-item label="Disaggregation on Age">
            <RadioGroup
              v-model="currentValue.disaggregation_on_age"
              @on-change="updateValue"
            >
              <Radio label="Yes"></Radio>
              <Radio label="No"></Radio>
              <Radio label="Partial"></Radio>
            </RadioGroup>
          </i-form-item>
        </Card>
      </i-col>
    </Row>

    <Row>
      <i-col span="12">
        <Card dis-hover>
          <i-form-item label="Data on Returns">
            <RadioGroup
              v-model="currentValue.data_on_returns"
              @on-change="updateValue"
            >
              <Radio label="Yes"></Radio>
              <Radio label="No"></Radio>
              <Radio label="Partial"></Radio>
            </RadioGroup>
          </i-form-item>
        </Card>
      </i-col>
      <i-col span="12">
        <Card dis-hover>
          <i-form-item label="Data on Deaths">
            <RadioGroup
              v-model="currentValue.data_on_deaths"
              @on-change="updateValue"
            >
              <Radio label="Yes"></Radio>
              <Radio label="No"></Radio>
              <Radio label="Partial"></Radio>
            </RadioGroup>
          </i-form-item>
        </Card>
      </i-col>
    </Row>

    <Row>
      <i-col span="12">
        <Card dis-hover>
          <i-form-item label="Data on Births">
            <RadioGroup
              v-model="currentValue.data_on_births"
              @on-change="updateValue"
            >
              <Radio label="Yes"></Radio>
              <Radio label="No"></Radio>
              <Radio label="Partial"></Radio>
            </RadioGroup>
          </i-form-item>
        </Card>
      </i-col>
      <i-col span="12">
        <Card dis-hover>
          <i-form-item label="Data on Cross-border movements">
            <RadioGroup
              v-model="currentValue.data_on_cross_border_movements"
              @on-change="updateValue"
            >
              <Radio label="Yes"></Radio>
              <Radio label="No"></Radio>
              <Radio label="Partial"></Radio>
            </RadioGroup>
          </i-form-item>
        </Card>
      </i-col>
    </Row>

    <Row>
      <i-col span="12">
        <Card dis-hover>
          <i-form-item label="Data on Local integration">
            <RadioGroup
              v-model="currentValue.data_on_local_integration"
              @on-change="updateValue"
            >
              <Radio label="Yes"></Radio>
              <Radio label="No"></Radio>
              <Radio label="Partial"></Radio>
            </RadioGroup>
          </i-form-item>
        </Card>
      </i-col>
      <i-col span="12">
        <Card dis-hover>
          <i-form-item label="Data on settlements elsewhere">
            <RadioGroup
              v-model="currentValue.data_on_settlements_elsewhere"
              @on-change="updateValue"
            >
              <Radio label="Yes"></Radio>
              <Radio label="No"></Radio>
              <Radio label="Partial"></Radio>
            </RadioGroup>
          </i-form-item>
        </Card>
      </i-col>
    </Row>
  </Row>
</template>

<script>
const emptyValue = {
  methodology: [],
  data_on_births: "",
  data_on_deaths: "",
  data_on_returns: "",
  reporting_units: [],
  data_trianglation: "",
  disaggregation_sex: "",
  disaggregation_on_age: "",
  geographical_coverage: "",
  frequency_of_reporting: "",
  data_on_local_integration: "",
  geographical_disaggregation: "",
  data_on_settlements_elsewhere: "",
  data_on_cross_border_movements: "",
};

export default {
  props: {
    value: { type: Object, default: () => emptyValue },
  },
  data() {
    return {
      currentValue: this.value || emptyValue,
    };
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue || emptyValue;
    },
  },
  methods: {
    updateValue() {
      this.$emit("input", this.currentValue);
    },
  },
};
</script>

<style lang="css"></style>
